import React, { FC } from 'react';
import { configAxios } from '../../axiosUtils';
import { PageLayout } from './PageLayout';
import { AppWrapper } from './AppWrapper';

configAxios();

type Props = {
  subHeader?: React.ReactElement;
  isMarketingLayout?: boolean;
};

export const AppWrapperWithPageLayout: FC<Props> = ({
  children,
  subHeader,
  isMarketingLayout,
}) => {
  return (
    <AppWrapper>
      <PageLayout subHeader={subHeader} isMarketingLayout={isMarketingLayout}>
        {children}
      </PageLayout>
    </AppWrapper>
  );
};
